'use client';

import { NotFound } from '@mentimeter/content-ui/Error';
import { useUser } from '@mentimeter/user';

export default function NotFoundPage() {
  const user = useUser();
  return <NotFound user={user} />;
}
